import './index.scss'
import React, { useState, useEffect, useCallback, useLayoutEffect } from 'react'
import { Card, Button, Switch } from '@material-ui/core'
import FormItem from 'components/FormItem'
import ActiveSwitch from 'components/ActiveSwitch'
import { AutoCompleteNew } from 'components/Select'
import { MoveResourceTypeOptions, S3PreSignType } from 'common/enum'
import { fetchWorkoutOptions, optionEnum } from 'views/concerns/workoutOptions'
import { S3UploaderWithInput } from 'components/S3UploadInput'
import { moveResourceUpsertPromise } from 'api/MoveWorkout'

const requiredColumns = [{ key: 'name' }]
export default function WorkoutCategoryUpsertForm (props) {
  const { mode, data, history } = props
  const [moveResource, setMoveResource] = useState({})
  const [options, setOptions] = useState([])
  const { trainer } = optionEnum
  const [isHFlip, setIsHFlip] = useState(null)

  useLayoutEffect(() => {
    if (isHFlip !== null) return
    if (moveResource.source_id === undefined) return

    setIsHFlip(!!moveResource.source_id)
  }, [isHFlip, moveResource.source_id])

  useLayoutEffect(() => {
    fetchWorkoutOptions(trainer).then(resp => setOptions(resp))
  }, [trainer])

  useEffect(() => {
    setMoveResource({
      oldId: data.id,
      ...data,
    })
  }, [data])

  function handleSubmit () {
    moveResourceUpsertPromise(moveResource)
      .then(() => history.goBack())
  }

  const handleValueChange = useCallback((map) => {
    setMoveResource({ ...moveResource, ...map })
  }, [moveResource])

  return (
    <div className={'root'}>
      <Card className={'form-container'}>
        <FormItem name={'name'} value={moveResource.name} onChange={map => { handleValueChange(map) } } />

        <FormItem label='Type'>
          <AutoCompleteNew options={MoveResourceTypeOptions} value={moveResource.type} onChange={(event, selected) => handleValueChange({type: (selected || {value: null}).value})} />
        </FormItem>

        <FormItem label='Trainer'>
          <AutoCompleteNew options={options[trainer] || []} value={moveResource.trainer_id} onChange={(event, selected) => handleValueChange({trainer_id: (selected || {value: null}).value})} />
        </FormItem>

        <FormItem label='Flip Horizontal' name={'hflip'}>
          <Switch name='hflip' checked={isHFlip} onChange={e => {
            setIsHFlip(e.target.checked)
            handleValueChange({ source_id: null })
          }} />
        </FormItem>

        {
          isHFlip
            ? <FormItem name='source_id' value={moveResource.source_id} placeholder='move resource id' onChange={map => { handleValueChange(map) } } />
            : <FormItem name='file_path' value={moveResource.file_path} placeholder='msk/10.mp4' onChange={map => { handleValueChange(map) } } />
        }

        <S3UploaderWithInput label='Preview Cover' name={'preview_cover_url'}
          filenames={moveResource.preview_cover_url} fileType={S3PreSignType.MoveBaseWorkout}
          setFilenames={filenames => handleValueChange({ preview_cover_url: filenames })} />

        {
          mode === 'edit' && <>
            <FormItem label='Video' name={'video_url'} value={moveResource.video_url} readonly placeholder='upload the video at Video/Workout Resource' onChange={map => { handleValueChange(map) } } />
            <FormItem label='Preview Video' name={'preview_video_url'} value={moveResource.preview_video_url} readonly onChange={map => { handleValueChange(map) } } />
            <FormItem name={'continue_time'} value={moveResource.continue_time} onChange={map => { handleValueChange(map) } } />
          </>
        }

        <FormItem label={'Active'} name={'active'}>
          <ActiveSwitch mode={mode} body={moveResource} columns={requiredColumns} setBody={setMoveResource} isNeedCheck={true} />
        </FormItem>

        <Button fullWidth className='save-btn' color='primary' size='large' type='submit' variant='contained' onClick={handleSubmit}>
          Submit
        </Button>
      </Card>
    </div>
  )
}